module.exports = __webpack_public_path__ + "static/media/moistrol-logo.4d4c106e.jpg";